import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY = '/reports/campaign/<id>/content';

export function useCampaignReportContentQuery({
	campaignId,
	impersonationContext,
	enabled = true,
}: {
	campaignId: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IRawRichTextContentState>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `reports/campaign/${encodeURIComponent(campaignId)}/content`,
					impersonationContext,
				}),
				'GET'
			),
		queryKey: [BASE_QUERY, campaignId, impersonationContext?.account?.id],
		enabled,
	});
}
